<template>
 <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Definir Imagem</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="uploadLogo" autocomplete="off">
        <div class="row">
            <div class="col-md-12">
                <div class="custom-file">
                    <input type="file" class="custom-file-input" 
                      @change="processFile($event)" id="validatedCustomFile" required>
                    <label class="custom-file-label" for="validatedCustomFile">Informe o arquivo...</label>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center m-3">
            <img v-if="imageUrl" id="imageUploadTmp" alt="image" width="90px" height="90px" 
              :src="imageUrl" class="rounded-circle img-fluid">
          </div>
        </div>
        <div class="row">
              <div class="col text-right mb-2">
                <div class="btn-login">
                  <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                  <button type="submit" class="btn btn-primary">Salvar</button>
                </div>
              </div>
            </div>
      </form>
    </div>
  </div>
</template>
<script>
import * as http from 'axios'

export default {
  mounted () {
    this.imagePreview = null
    this.logo = null
  },
  computed: {
    imageUrl () {
      if (this.imagePreview) {
        return this.imagePreview
      }
      return null
    }
  },
  data () {
    return {
      logo: null,
      imagePreview: null
    }
  },
  methods: {
    async uploadLogo () {
      try {
        this.$store.dispatch('setLoading', true)
        const payload = new FormData()
        payload.append('file', this.logo)
        await http.post(`/redeImagem/${this.$store.getters.rede._id}`, payload)
        this.$store.dispatch('setLoading', false)
        window.jQuery('#drAcheiModal').modal('hide')
        window.location.reload()
      } catch (error) {
        console.log(error)
      }
    },
    processFile (event) {
      this.logo = event.target.files[0]
      if (this.logo) {
        let file = new FileReader()
        const _self = this
        file.onload = (e) => {
          _self.imagePreview = e.target.result
        }
        file.readAsDataURL(this.logo)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ModalUploadImageRede.vue